import { createSelector } from 'reselect';

import { AppState } from '../../types';

export const selectCustomersList = (state: AppState) => state.customers.list;

export const selectCustomer = (state: AppState) => state.customers.selected;

export const isCustomerPersistent = createSelector(
  selectCustomer,
  (state) => Boolean(state.data?.id),
);

export const selectCustomerName = createSelector(
  selectCustomer,
  (state) => state.data?.ref.full_name_first_last,
);
